<template>
  <section id="news" class="section" data-component="news-center">
    <div class="container">
      <div class="section-header reveal">
        <span class="card-tag">新闻中心</span>
        <h2 class="card-title">了解海曦最新动态</h2>
      </div>
      <div v-if="newsList.length" class="news-grid">
        <div
          v-for="(n, i) in newsList"
          :key="n.id"
          class="news-card reveal"
          :class="`reveal-delay-${(i % 3) + 1}`"
        >
          <div class="news-date">{{ formatHomeNewsDate(n.date) }}</div>
          <h3>{{ n.title }}</h3>
          <p>{{ n.summary }}</p>
          <RouterLink
            :to="{ name: 'news-detail', params: { id: n.id } }"
            class="news-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            阅读更多
            <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
              <path
                d="M0.75 8.99999C0.525 8.99999 0.375 8.92499 0.225 8.77499C-0.075 8.47499 -0.075 8.02499 0.225 7.72499L7.725 0.225C8.025 -0.0749999 8.475 -0.0749999 8.775 0.225C9.075 0.525 9.075 0.974999 8.775 1.275L1.275 8.77499C1.125 8.92499 0.975 8.99999 0.75 8.99999Z"
                fill="#0095FF"
              />
              <path
                d="M8.25009 8.25C7.80009 8.25 7.50009 7.95 7.50009 7.5V1.5H1.50009C1.05009 1.5 0.750092 1.2 0.750092 0.75C0.750092 0.3 1.05009 0 1.50009 0H8.25009C8.70009 0 9.00009 0.3 9.00009 0.75V7.5C9.00009 7.95 8.70009 8.25 8.25009 8.25Z"
                fill="#0095FF"
              />
            </svg>
          </RouterLink>
        </div>
      </div>
      <p v-else-if="!loading" class="news-empty">暂无新闻</p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useFrontCmsStore } from '@/stores/frontCms';
import { mapFrontNewsToCards } from '@/utils/frontCmsMappers';
import '@/styles/newhome/home/news.css';

const HOME_NEWS_COUNT = 3;
/** 与 NewsPage 一致，共用缓存与 store 状态 */
const NEWS_PAGE_SIZE = 12;
const NEWS_PAGE_KEY = `1:${NEWS_PAGE_SIZE}`;

const cms = useFrontCmsStore();
const { newsPage, syncing } = storeToRefs(cms);

const loading = computed(() => !!syncing.value.newsPage);

const newsList = computed(() => {
  if (newsPage.value.pageKey !== NEWS_PAGE_KEY) {
    return [];
  }
  return mapFrontNewsToCards(newsPage.value.records).slice(0, HOME_NEWS_COUNT);
});

cms.hydrateFromCache();
void cms.syncNewsPage(1, NEWS_PAGE_SIZE);

function formatHomeNewsDate(iso: string): string {
  const [y, m] = iso.split('-');
  if (!y || !m) return iso || '';
  return `${y}年${Number(m)}月`;
}
</script>

<style scoped lang="scss">
#news {
  .card-tag {
    color: #0d0e13;
    border-radius: 18.91px;
    border: 0.63px solid #0d0e13;
  }

  .card-title {
    color: #0d0e13;
  }

  .news-empty {
    margin: 24px 0 0;
    color: #666;
    font-size: 14px;
  }
}
</style>
